import React, { Component } from "react";
import { LoadingOutlined } from "@ant-design/icons";

class LoadingView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LoadingOutlined style={{ fontSize: 28 }} />
      </div>
    );
  }
}

export default LoadingView;



// WEBPACK FOOTER //
// ./src/views/NaduChat/components/LoadingView.jsx